import { RadioGroup, Stack } from '@chakra-ui/react'
import cn from 'clsx'
import { Dispatch, FC, SetStateAction } from 'react'

import { Button, Typography } from '@/components/ui'
import Spinner from '@/components/ui/spinner/Spinner'

import { IPlatform } from '@/types/uploadForm.interface'

interface IModalSelectPlatformProps {
	platformList: IPlatform[]
	isPlatformLoading: boolean
	setOpenFormModal: Dispatch<SetStateAction<boolean>>
	handleUpload: () => void
	firstPlatform: string
	setFirstPlatform: Dispatch<SetStateAction<string>>
}

const ModalSelectPlatform: FC<IModalSelectPlatformProps> = ({
	platformList,
	isPlatformLoading,
	setOpenFormModal,
	handleUpload,
	firstPlatform,
	setFirstPlatform
}) => {
	const isPlatform = platformList.length > 0 && !isPlatformLoading

	return (
		<div className='flex justify-center'>
			<div className='flex flex-col gap-8'>
				<Typography variant='text-xlarge'>Select platform</Typography>

				<RadioGroup.Root
					value={firstPlatform}
					onValueChange={e => setFirstPlatform(e.value)}
					className={cn(!isPlatform && 'relative h-[120px]')}
				>
					{!isPlatform && <Spinner className='absolute' />}
					{isPlatform && (
						<Stack gap='16px' className={cn('relative flex text-start')}>
							{platformList.map(item => (
								<RadioGroup.Item key={item.value} value={item.value}>
									<RadioGroup.ItemHiddenInput />
									<RadioGroup.ItemControl
										backgroundColor='gray.200'
										width='24px'
										height='24px'
									>
										<RadioGroup.ItemIndicator width='24px' height='24px' />
									</RadioGroup.ItemControl>
									<RadioGroup.ItemText>{item.label}</RadioGroup.ItemText>
								</RadioGroup.Item>
							))}
						</Stack>
					)}
				</RadioGroup.Root>

				<Button
					className='bg-gray-600 hover:bg-black px-[232px] py-[16px] rounded-[8px]'
					classNameText='text-[18px] font-[600] leading-[24px]'
					disabled={!isPlatform}
					onClick={() => {
						handleUpload()
						setOpenFormModal(true)
					}}
				>
					Upload
				</Button>
			</div>
		</div>
	)
}

export default ModalSelectPlatform
